import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateTime, Interval } from 'luxon';

export function createOverlapValidator(getAllowIntersections: () => boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormArray)) {
      return null;
    }

    const allowIntersections = getAllowIntersections();

    const intervals = control.controls.map((c: AbstractControl<{ from: string; to: string } | null>) => {
      if (!c.value || !c.value.from || !c.value.to) {
        return null;
      }

      const { from, to } = c.value;
      const start = DateTime.fromISO(from);
      const end = DateTime.fromISO(to);

      if (!start.isValid || !end.isValid) {
        return null;
      }

      const interval = Interval.fromDateTimes(start, end);

      return interval.isValid ? interval : null;
    });

    const overlappingIndices = new Set<number>();
    const checkAdjacent = !allowIntersections;

    for (let i = 0; i < intervals.length; i++) {
      const intervalA = intervals[i];
      if (!intervalA) continue;

      for (let j = i + 1; j < intervals.length; j++) {
        const intervalB = intervals[j];
        if (!intervalB) continue;

        if (intervalA.overlaps(intervalB)) {
          overlappingIndices.add(i);
          overlappingIndices.add(j);
        } else if (
          checkAdjacent &&
          (intervalA.end.toMillis() === intervalB.start.toMillis() ||
            intervalB.end.toMillis() === intervalA.start.toMillis())
        ) {
          overlappingIndices.add(i);
          overlappingIndices.add(j);
        }
      }
    }

    return overlappingIndices.size > 0 ? { overlaps: Array.from(overlappingIndices) } : null;
  };
}
